import { useEffect, useState, useRef } from 'react';

/**
 * スクロールアニメーション用カスタムフック
 * IntersectionObserverを使用して要素の可視性を検出
 * @param {number} threshold - 可視性のしきい値（0-1）
 * @returns {[React.MutableRefObject<null>, boolean]} - ref と isVisible のタプル
 */
const useScrollAnimation = (threshold = 0.15) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [threshold]);

  return [ref, isVisible];
};

export default useScrollAnimation;
